module.exports = __webpack_public_path__ + "static/media/logo-howto.9bcce02f.png";